import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule } from '@com-delta-idp/mnx-ui-kit';
import { UpgradesComponent } from './upgrades.component';

@NgModule({
  declarations: [UpgradesComponent],
  imports: [CommonModule, ImageModule],
  exports: [UpgradesComponent]
})
export class UpgradesModule {}
